(function ($, w) {
    $(function () {
        $.validator.addMethod(
            "phonenumber",
            function (value, element, params) {
                if (value) value = value.replace(/( |-|\(|\))/g, "");
                return new RegExp(params).test(value);
            },
            "A valid phone number is required"
        );
      $.validator.addMethod(
        "rut",
        function (value, element, params) {
            const dvFormule = (T) => {
              let M = 0,
                S = 1;
              for (; T; T = Math.floor(T / 10)) {
                S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
              }
              return S ? S - 1 : 'k';
            };
            // to validate this, we need something like this-> 'XXXXXXXX-X' (chilean rut)
            if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(value)) {
              return false;
            }

            const tmp = value.split('-');
            let digv = tmp[1];
            const rut = +tmp[0];
            if (digv == 'K') {
              digv = 'k';
            }
            return dvFormule(rut) == digv;
        },
        ""
      );
    });
})(jQuery, window);
